<h2 mat-dialog-title style="margin-bottom: 20px">Manually add free registration</h2>

<mat-dialog-content>
    <form [formGroup]="registrationForm">
        <fieldset style="margin-top:10px; display: flex; flex-direction: row; gap: 5px;">
            <div class="form-row">
                <mat-form-field appearance="outline" [style.width]="200">
                    <mat-label>Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    @if (registrationForm.get('registrationDate')?.invalid &&
                    registrationForm.get('registrationDate')?.touched) {
                    <mat-error>Date is required. </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" [style.width]="300">
                    <mat-label>Organisation</mat-label>
                    <input matInput type="text" formControlName="organisation">
                    @if(registrationForm.get('organisation')?.invalid && registrationForm.get('organisation')?.touched)
                    {
                    <mat-error> Organisation is required. </mat-error>
                    }
                </mat-form-field>
            </div>
        </fieldset>

        <fieldset>
            <legend>Attendees</legend>

            <div formGroupName="firstAttendee" class="form-row">
                <mat-form-field appearance="outline" class="attendee-form-field">
                    <mat-label>Job title</mat-label>
                    <input matInput type="text" formControlName="jobTitle">
                </mat-form-field>

                <mat-form-field appearance="outline" class="attendee-form-field">
                    <mat-label>First name</mat-label>
                    <input matInput type="text" formControlName="firstName">
                    @if (registrationForm.get('firstAttendee.firstName')?.invalid &&
                    registrationForm.get('firstAttendee.firstName')?.touched) {
                    <mat-error>First name is required. </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" class="attendee-form-field">
                    <mat-label>Last name</mat-label>
                    <input matInput type="text" formControlName="lastName">
                    @if (registrationForm.get('firstAttendee.lastName')?.invalid &&
                    registrationForm.get('firstAttendee.lastName')?.touched) {
                    <mat-error>Last name is required. </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" class="attendee-form-field">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="email">
                    @if (registrationForm.get('firstAttendee.email')?.invalid &&
                    registrationForm.get('firstAttendee.email')?.touched) {
                    <mat-error>Valid email is required. </mat-error>
                    }
                </mat-form-field>
            </div>

            <div formArrayName="additionalAttendees">
                <div *ngFor="let attendee of additionalAttendees.controls; let i = index" [formGroupName]="i"
                    class="form-row">
                    <mat-form-field appearance="outline" class="attendee-form-field">
                        <mat-label>Job title</mat-label>
                        <input matInput type="text" formControlName="jobTitle">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="attendee-form-field">
                        <mat-label>First name</mat-label>
                        <input matInput type="text" formControlName="firstName">
                        @if (attendee.get('firstName')?.invalid && attendee.get('firstName')?.touched) {
                        <mat-error>First name is required. </mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="attendee-form-field">
                        <mat-label>Last name</mat-label>
                        <input matInput type="text" formControlName="lastName">
                        @if (attendee.get('lastName')?.invalid && attendee.get('lastName')?.touched) {
                        <mat-error>Last name is required. </mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="attendee-form-field">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email">
                        @if (attendee.get('email')?.invalid && attendee.get('email')?.touched) {
                        <mat-error>Valid email is required. </mat-error>
                        }
                    </mat-form-field>

                    <button mat-icon-button color="warn" (click)="deleteAttendee(i)" title="Remove attendee">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>

            <div class="attendee-button-row">
                <button mat-button type="button" (click)="addAttendee()"><mat-icon>add</mat-icon>Add attendee</button>
            </div>
        </fieldset>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="registrationForm.invalid">Save</button>
</mat-dialog-actions>